import React from 'react';
import { Button, ButtonProps, Flex, theme } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

import { guidesLocation } from '../integrationGuidesRoute';

export type CloudflareHelpActionsProps = {
  askNexusLabel: string;
  guidesLabel: string;
  onAskNexus: () => void;
  size?: ButtonProps['size'];
};

/**
 * Buttons, not `Typography.Link`: an antd link with no `href` is not focusable
 * and not activatable from the keyboard.
 */
const CloudflareHelpActions = ({ askNexusLabel, guidesLabel, onAskNexus, size }: CloudflareHelpActionsProps) => {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Flex vertical align="start" gap={token.marginXXS}>
      <Button
        type="link"
        size={size}
        icon={<ArrowRightOutlined aria-hidden />}
        onClick={onAskNexus}
        style={{ padding: 0 }}
      >
        {askNexusLabel}
      </Button>
      <Button
        type="link"
        size={size}
        icon={<ArrowRightOutlined aria-hidden />}
        onClick={() => navigate(guidesLocation(location.search))}
        style={{ padding: 0 }}
      >
        {guidesLabel}
      </Button>
    </Flex>
  );
};

export default CloudflareHelpActions;
